import { Enums, Helpers, Mappers } from '@bode-canada/core';
import routes from '../constants/routes';
import { QueryParams } from '../constants/QueryParams';
import { EXCLUDED_COMMUNITY_NONE_VALUE } from '../components/page-specific/listing/summary/constants';
import NumberHelper from './NumberHelper';

const PARAM_SEPARATOR = '-';
const ID_PARAM_POSITION = 0;
const LOT_SIZE_ACCURACY = 0;

export default class PropertyPathHelper {
  static parseIdFromParam(idParam) {
    const id = idParam.split(PARAM_SEPARATOR)[ID_PARAM_POSITION];

    return Number(id);
  }

  static generateReviewRouteFromListing({ listingId }) {
    return `${routes.listingEditing}/${listingId}`;
  }

  static generateDraftRouteFromListing({ listingId }) {
    return `${routes.listHome}?${QueryParams.ListingId}=${listingId}`;
  }

  static generateActiveRouteFromListing({ listingId }) {
    return `${routes.listings}/${listingId}`;
  }

  static generateSoldRouteFromListing({
    addressId,
    listingId,
    city,
    community,
    buildingClass,
    buildingType,
    beds,
    lotSizeSqft,
  }) {
    const propertyClass = Mappers.BuildingTypeMapper.mapBuildingClassToPropertyClass(buildingClass);
    const addressSegment = Helpers.StringHelper.joinStrings([
      addressId,
      Helpers.StringHelper.toKebabCase(city),
      Helpers.StringHelper.toKebabCase(this.#checkCommunity(community)),
      Helpers.StringHelper.toKebabCase(propertyClass),
      ...this.#getSizePathSegments(buildingType, beds, lotSizeSqft),
    ], PARAM_SEPARATOR).toLowerCase();

    return `${routes.soldProperty}/${addressSegment}?${QueryParams.ListingId}=${listingId}`;
  }

  static #checkCommunity(community) {
    return EXCLUDED_COMMUNITY_NONE_VALUE !== community && community;
  }

  static #getSizePathSegments(buildingType, beds, lotSize) {
    if (!buildingType || !(beds || lotSize)) {
      return [];
    }

    return buildingType === Enums.BuildingTypeEnum.VACANT_LAND
      ? [NumberHelper.sqftToAcres(lotSize, LOT_SIZE_ACCURACY), 'acres']
      : [beds, Helpers.StringHelper.pluralize(beds, 'bed')];
  }
}
